module.exports = __webpack_public_path__ + "static/media/main_picture_bg@2x.a07b0e8a.png";